import React, { useState } from "react";
import QrScanner from "react-qr-scanner";
import { useNavigate } from "react-router-dom";
import MobileWrapper from "../../components/MobileWrapper";
import { FiCamera, FiRefreshCw } from "react-icons/fi";
import { IoQrCodeOutline } from "react-icons/io5";
import { useSelector } from "react-redux";
import UnderConstruction from "../Dashboard/AdminDashboard/UnderConstruction";

export default function ScanQR() {
  const currentUser = useSelector((state) => state.userObject);
  const [result, setResult] = useState(null);
  const [facingMode, setFacingMode] = useState("environment"); // Default to back camera
  const [scanning, setScanning] = useState(true);
  const navigate = useNavigate();

  const allowedRoles = ["admin", "security", "reception", "security-guard"];

  const isAllowed = currentUser.roles.some((role) =>
    allowedRoles.includes(role)
  );

  const handleScan = (data) => {
    if (data) {
      setResult(data);
      setScanning(false);
      // You can now navigate to the scanned URL, e.g.
      setTimeout(() => {
        navigate(data.text);
      }, 1500);
    }
  };

  const handleError = (err) => {
    console.error(err);
  };

  const toggleCamera = () => {
    // Toggle between 'environment' and 'user' to switch cameras
    if (facingMode === "environment") {
      setFacingMode("user");
    } else {
      setFacingMode("environment");
    }
  };

  const resetScan = () => {
    setResult(null);
    setScanning(true);
  };

  return (
    <>
      {isAllowed ? (
        <MobileWrapper label={"Scan QR Code"}>
          <div
            className="flex flex-col items-center p-4 h-full"
            style={{ backgroundColor: "#f5f5f7" }}
          >
            <div
              className="flex items-center gap-2 text-lg font-medium mb-4"
              style={{ color: "#363062" }}
            >
              <IoQrCodeOutline size={22} />
              <span>Scan QR Code</span>
            </div>

            <div
              className="relative w-full max-w-sm mb-4 rounded-lg overflow-hidden shadow-md"
              style={{
                aspectRatio: "1/1",
                border: "8px solid white",
                boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
              }}
            >
              {scanning ? (
                <>
                  <div
                    className="absolute inset-0 border-4 border-dashed rounded-lg z-10"
                    style={{ borderColor: "#8FCD00" }}
                  ></div>
                  <QrScanner
                    delay={300}
                    onError={handleError}
                    onScan={handleScan}
                    style={{ width: "100%", height: "100%" }}
                    constraints={{
                      audio: false,
                      video: { facingMode: facingMode },
                    }}
                  />
                </>
              ) : (
                <div className="flex items-center justify-center h-full w-full bg-white">
                  <div className="text-center p-4">
                    <div
                      className="inline-flex items-center justify-center mb-3 p-2 rounded-full"
                      style={{ backgroundColor: "#8FCD00" }}
                    >
                      <IoQrCodeOutline size={28} color="white" />
                    </div>
                    <p
                      className="text-sm font-medium"
                      style={{ color: "#363062" }}
                    >
                      QR Code detected!
                    </p>
                    <p className="text-xs text-gray-500 mt-1">Redirecting...</p>
                  </div>
                </div>
              )}
            </div>

            {result && (
              <div
                className="w-full max-w-sm mb-4 p-3 rounded-lg"
                style={{ backgroundColor: "#363062", color: "white" }}
              >
                <p className="text-xs">Detected URL:</p>
                <p className="text-sm font-medium truncate">{result.text}</p>
              </div>
            )}

            <div className="flex gap-3 mt-2">
              <button
                onClick={toggleCamera}
                className="flex items-center justify-center w-12 h-12 rounded-full shadow-md"
                style={{ backgroundColor: "#363062" }}
              >
                <FiRefreshCw size={20} color="white" />
              </button>

              {!scanning && (
                <button
                  onClick={resetScan}
                  className="flex items-center justify-center gap-2 px-4 h-12 rounded-full shadow-md"
                  style={{ backgroundColor: "#8FCD00", color: "white" }}
                >
                  <FiCamera size={18} />
                  <span className="text-sm font-medium">Scan Again</span>
                </button>
              )}
            </div>
          </div>
        </MobileWrapper>
      ) : (
        <UnderConstruction />
      )}
    </>
  );
}
